"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InternalSettingsFieldComponents = void 0;
const autocomplete_1 = require("./field-components/autocomplete");
const select_1 = require("./field-components/select");
exports.InternalSettingsFieldComponents = {
    useSelect: select_1.useSelect,
    useAutocomplete: autocomplete_1.useAutocomplete,
};
//# sourceMappingURL=internal-settings-field-components.js.map